import {
  UpdateDiscountCodeInput,
  UpdateDiscountCodeOutput,
} from "@redotech/redo-order-editing-common/schemas/update-discount-code";

export const updateDiscountCodeSelfServe = {
  name: "updateDiscountCodeSelfServe" as const,
  input: UpdateDiscountCodeInput,
  output: UpdateDiscountCodeOutput,
};
